const ENVIRONMENT = import.meta.env.VITE_REACT_APP_ENVIRONMENT as string;

export const canTrackUser = (email = ""): boolean => {
  if (ENVIRONMENT === "development") {
    return email.endsWith("@frase.io");
  }
  return true;
};
